import { render, staticRenderFns } from "./WorkHeaderPicker.vue?vue&type=template&id=0580cb4e&scoped=true"
import script from "./WorkHeaderPicker.vue?vue&type=script&lang=js"
export * from "./WorkHeaderPicker.vue?vue&type=script&lang=js"
import style0 from "./WorkHeaderPicker.vue?vue&type=style&index=0&id=0580cb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580cb4e",
  null
  
)

export default component.exports